var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};

module.exports = {
  generic: {
    results: function(d) { return plural(d.copy, 0, en, { "0": "0 Results", "1": "1 نتيجة", other: number(d.copy, "copy") + "نتائج" }); }
  },
  search: {
    title: function(d) { return "البحث عن النتائج"; },
    results: function(d) { return "“" + d.searchTerm + "”"; }
  },
  product: {
    notStockedOnLine: function(d) { return "عذرًا، هذه القطعة غير متاحة للبيع الآن"; },
    productCode: function(d) { return "رمز المنتج"; },
    soldOut: function(d) { return "نعتذر، هذه القطعة غير متوفرة حاليا. تتبعوا هذا التصميم حتى لا يفوتكم في حال أصبح متاحًا مرّة أخرى"; },
    buyableFalse: function(d) { return "عذرًا، هذه القطعة غير متاحة للبيع "; },
    unavailableProduct: function(d) { return "عذرًا، هذه القطعة غير متاحة للبيع"; },
    shippingRestriction: function(d) { return "عذرًا، هذه القطعة غير متاحة للبيع في موقعك"; },
    restrictedToEip: function(d) { return "نعتذر، هذه القطعة غير متوفرة حاليا. تتبعوا هذا التصميم من خلال إضافته إلى قائمة أمنياتكم"; },
    doNotForgetToAddToWishlistMessage: function(d) { return "لا تنسوا إضافة القطعة التي ترغبون بها إلى قائمة الامنيات"; },
    shippingRestrictionsNotificationMessage: function(d) { return "قد يتم تطبيق قيود الشحن [معرفة المزيد] (/" + d.locale + "/page/help/customer-service/delivery/)"; },
    needAdvice: function(d) { return "هل أنتم بحاجة إلى أخذ نصيحة؟"; },
    needAdviceCTA: function(d) { return "يُرجى التواصل مع خدمة رعاية العملاء"; },
    finalSaleNotification: function(d) { return "التنزيلات النهائية - لا يمكن إرجاع هذا المنتج"; },
    genericMessage: function(d) { return ""; },
    Brand: function(d) { return "العلامة التجارية"; },
    Illustrative: function(d) { return "مثال توضيحي"; },
    productTitle: function(d) { return "عنوان المنتج"; }
  },
  considered: {
    badge: function(d) { return "الاستدامة"; },
    consideredAccordion: function(d) { return "نحن فخورون بإدراج هذا المنتج ضمن 'التشكيلة المصممة للاستدامة' كجزء من التزامنا بتوفير أزياء صديقة للإستدامة على نطاق أوسع لعملائنا."; },
    actionText: function(d) { return "معرفة المزيد"; },
    href: function(d) { return "/editorial/our-considered-pledge"; },
    consideredAttributesTitle: function(d) { return "هل ينطبق على هذا المنتج شروط الاستدامة؟"; },
    consideredDelivery: function(d) { return "يعدّ خيار التوصيل هذا الأقل على الإطلاق بشأن الانبعاثات الكربونية في الوقت الحالي"; },
    consideredFilters: function(d) { return "عرض جميع المنتجات في قائمة الاستدامة"; }
  },
  colourAndSize: {
    colour: function(d) { return "اللون"; },
    size: function(d) { return "المقاس"; },
    button1: function(d) { return "مرحبًا"; },
    button2: function(d) { return "مرحبًا"; },
    line1: function(d) { return "مرحبًا"; },
    line2: function(d) { return "مرحبًا"; }
  },
  pagination: {
    first: function(d) { return "الأول"; },
    previous: function(d) { return "السابق"; },
    next: function(d) { return "التالي"; },
    last: function(d) { return "الأخير"; },
    status: function(d) { return "الصفحة " + d.currentPage + " من " + d.totalPages; }
  },
  contactUsCTA: {
    personalShopper: {
      title: function(d) { return "تحدّثوا مع فريق التسوّق الخاص بنا لإضافتكم على قائمة انتظار هذه القطعة"; },
      titleAssignedPS: function(d) { return "Speak to " + d.name + " to be added to the waiting list for this item"; },
      emailLabel: function(d) { return "البريد الإلكتروني"; },
      emailStructure: {
        subject: function(d) { return "Please add me to the waiting list for " + d.name; },
        body: function(d) { return "Please add me to the waiting list for this product: " + d.url; }
      }
    },
    sizeAndFit: {
      title: function(d) { return "Still not sure what size to purchase?"; },
      titleEip: function(d) { return "Our Personal Shopping Team is on hand to provide detailed product information."; },
      titlePersonalShopper: function(d) { return "Your Personal Shopper is on hand to provide detailed product information."; },
      emailLabel: function(d) { return "Email"; },
      emailStructure: {
        subject: function(d) { return "I would like your advice for " + d.name; },
        body: function(d) { return "I am still not sure about sizing for this product: " + d.url; }
      }
    },
    badge: function(d) { return "الإتصال بخبير التسوق الشخصي"; },
    eip: {
      soldOutOnline: {
        title: function(d) { return "Contact our Personal Shopping Team for help finding an alternative"; },
        titleAssignedPS: function(d) { return "Contact " + d.name + " for help finding an alternative"; },
        emailLabel: function(d) { return "Email"; },
        emailStructure: {
          subject: function(d) { return "I would like to know alternatives for " + d.name + " (Sold Out)"; },
          body: function(d) { return "I would like help to find an alternative for this sold out product: " + d.url; }
        }
      },
      notStockedOnline: {
        title: function(d) { return "Contact our Personal Shopping Team about purchasing this item"; },
        titleAssignedPS: function(d) { return "Contact " + d.name + " about purchasing this item"; },
        emailLabel: function(d) { return "Email"; },
        emailStructure: {
          subject: function(d) { return "I would like to purchase " + d.name; },
          body: function(d) { return "I would like to purchase this product: " + d.url; }
        }
      },
      buyableFalse: {
        title: function(d) { return "Contact our Personal Shopping Team about purchasing this item"; },
        titleAssignedPS: function(d) { return "Contact " + d.name + " about purchasing this item"; },
        emailLabel: function(d) { return "Email"; },
        emailStructure: {
          subject: function(d) { return "I would like to purchase " + d.name; },
          body: function(d) { return "I would like to purchase this product: " + d.url; }
        }
      },
      shippingRestricted: {
        title: function(d) { return "Contact our Personal Shopping Team to help you place your order"; },
        titleAssignedPS: function(d) { return "Contact " + d.name + " to help you place your order"; },
        emailLabel: function(d) { return "Email"; },
        emailStructure: {
          subject: function(d) { return "Please help me to place an order for " + d.name; },
          body: function(d) { return "Please help me to place an order for this product: " + d.url; }
        }
      },
      "default": {
        title: function(d) { return "Need sizing advice, a second opinion, or can’t find your size? Our Personal Shopping Team is here to help"; },
        titleAssignedPS: function(d) { return "Need sizing advice, a second opinion, or can’t find your size? " + d.name + " is here to help"; },
        emailLabel: function(d) { return "Email"; },
        emailStructure: {
          subject: function(d) { return "I would like your support " + d.name; },
          body: function(d) { return "I would like your support: " + d.url; }
        }
      },
      badge: function(d) { return "CONTACT PERSONAL SHOPPER"; }
    }
  },
  ctaButtons: {
    goToWishlist: function(d) { return "الذهاب إلى قائمة الأمنيات"; },
    addToWishlist: function(d) { return "إضافة إلى قائمة الأمنيات "; },
    addToWishlistLoading: function(d) { return "الإضافة إلى قائمة الأمنيات"; },
    addToBag: function(d) { return "إضافة المنتج إلى الحقيبة"; },
    goToBag: function(d) { return "الذهاب إلى حقيبة التسوّق"; },
    addToBagLoading: function(d) { return "إضافة المنتج إلى الحقيبة..."; },
    viewShoppingBag: function(d) { return "عرض حقيبة التسوق"; },
    viewMoreDetails: function(d) { return "عرض مزيد من التفاصيل"; }
  },
  price: {
    discountPercentage: function(d) { return "(" + d.discountPercentage + "%-)"; },
    discountPrice: function(d) { return "سعر الخصم"; },
    currencyExchange: function(d) { return "(تقريباً " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    ddpInformation: function(d) { return "(taxes and duties included)"; },
    wasPriceOriginal: function(d) { return "سعر التجزئة الموصى به: " + d.wasPrice; },
    wasPrice: function(d) { return "سعر التجزئة الموصى به:"; },
    originalPrice: function(d) { return "السعر الأصلي:"; },
    priceInformation: {
      title: function(d) { return "معلومات التسعير"; },
      subtitle: function(d) { return "تعرفوا على عرض الأسعار في موقع «THE OUTNET»:"; },
      descriptionRRPWithoutMinimumMessage: function(d) { return "**1. السعر الحالي:**\nالسعر الذي يتم عرض المنتج من خلاله حصريًا عبر التطبيق وموقع «THE OUTNET» الإلكتروني\n\n**2. سعر التجزئة الموصى به**\nسعر التجزئة الموصى به من قبل العلامة المصنّعة\n\n[اكتشفوا المزيد](" + d.link + ")"; },
      descriptionOriginalPriceWithoutMinimumMessage: function(d) { return "**1. السعر الحالي:**\nالسعر الذي يتم عرض المنتج من خلاله حصريًا عبر التطبيق وموقع «THE OUTNET» الإلكتروني\n\n**2. السعر الأصلي:**\nالسعر الذي تم إدراج المنتج به لأول مرة على تطبيق وموقع «THE OUTNET» الإلكتروني\n\n[اكتشفوا المزيد](" + d.link + ")"; }
    }
  },
  productListing: {
    unselectAll: function(d) { return "إلغاء تحديد الكل"; },
    allSelected: function(d) { return "الكل"; },
    numberSelected: function(d) { return d.number + " تم تحديده"; },
    refine: function(d) { return "التصنيف"; },
    priceFilter: {
      under: function(d) { return d.price; },
      over: function(d) { return d.price; }
    },
    apply: function(d) { return "تطبيق"; },
    clearFilters: function(d) { return "مسح التصنيفات"; },
    sortBy: function(d) { return "الترتيب حسب"; },
    topDesignersThisWeek: function(d) { return "أفضل مصممين هذا الأسبوع"; },
    azDesigners: function(d) { return "أسماء المصممون بالترتيب الأبجدي "; },
    searchDesigner: function(d) { return "البحث عن المصممين"; },
    noResultsSearch: function(d) { return "\"" + d.searchTerm + "\" لم نعثر على نتيجة لـ . يُرجى المحاولة لاحقًا"; },
    emptyList: function(d) { return select(d.pageType, { MARK_DOWN: "انتهت صلاحية الخصم", DESIGNER: "ترقبوا منتج الموسم الجديد", SEARCH: "لم يتم إيجاد نتائج لـ " + d.query, other: "No items found" }); },
    emptyListCopy: function(d) { return select(d.pageType, { SEARCH: "يرجى تجربة بحث آخر أو بدء التصفح أدناه", other: "" }); },
    emptyListGoTo: function(d) { return select(d.pageType, { other: "" }); },
    loadMore: function(d) { return "عرض المزيد"; },
    youHaveViewed: function(d) { return "لقد اطّلعت على " + d.totalNumberOfViewedProducts + "  من " + d.totalProducts + " المنتجات"; },
    loadPrevious: function(d) { return "تحميل السّابق"; },
    saleToggle: function(d) { return select(d.pageType, { DESIGNER: "تسوقوا من عروض " + d.designerName, other: "تسوقوا من جميع " + d.designerName }); },
    notifyTitle: function(d) { return "نأسف!"; },
    continueLink: function(d) { return "تسوّقوا من جميع التصاميم التي وصلتنا جديدًا"; },
    wishList: {
      title: function(d) { return "تمت إضافته إلى قائمة أمنياتكِ"; },
      subtitle: function(d) { return "يمكنكِ عرض القِطع التي ترغبينَ بها في أي وقت في حسابكِ"; },
      goToWishlist: function(d) { return "الانتقال إلى قائمة أمنياتكِ"; }
    }
  },
  contentHeader: {
    viewMoreCopy: function(d) { return "المزيد"; },
    sale: function(d) { return "Sale"; }
  },
  collapsableContent: {
    viewMore: function(d) { return "المزيد"; },
    viewLess: function(d) { return "أقل"; }
  },
  sizes: {
    sizeLabel: function(d) { return "المقاس"; },
    oneSizeLabel: function(d) { return "مقاس واحد"; },
    initialValue: function(d) { return "اختاري مقاسكِ"; },
    sizeConversion: function(d) { return "يتماشى " + d.sizeLabel + " مع " + d.localLanguageType + " " + d.localSizeValue; },
    sizeConversionModal: function(d) { return "يتماشى **" + d.sizeLabel + "** مع " + select(d.isSelected, { true: "**" + d.preferredSize + "**", other: d.preferredSize }); },
    sizeGuide: {
      viewProductMeasurements: function(d) { return "دليل المقاسات"; },
      viewSizeGuide: function(d) { return "دليل المقاسات"; },
      measuringGuide: function(d) { return "دليل المقاييس"; },
      title: function(d) { return "دليل المقاسات"; },
      sizeMeasurementsTitle: function(d) { return "ضبط المقاسات"; },
      sizeMeasurementsDetails: function(d) { return "تم ضبط مقاسات جميع القطع بواسطة فريق انسجام المقاسات من THE OUTNET"; },
      sizeConversionsTitle: function(d) { return "معلومات المقاس"; },
      sizeConversionsDetails: function(d) { return "هل أنتم غير متأكدين من مقاسكم؟ تحققوا من ذلك هنا"; },
      slideToScroll: function(d) { return "يُرجى التحريك للتمرير"; },
      noFurtherInfo: function(d) { return "لا يوجد معلومات إضافية عن المقاس"; },
      unavailable: function(d) { return " غير متاح في الموقع"; },
      cm: function(d) { return "سم"; },
      "in": function(d) { return "إنش"; },
      compareSize: {
        text: function(d) { return ""; },
        subText: function(d) { return ""; }
      },
      inStock: function(d) { return "متوفر"; },
      lowStock: function(d) { return "تبقّى عدد قليل"; },
      oneLeft: function(d) { return "تبقّت قطعة واحدة فقط"; },
      outOfStock: function(d) { return "نفِد من المخزن"; }
    }
  },
  seo: {
    azdesigners: {
      title: function(d) { return "تسوّقوا من قطع مصمم الأزياء الذي تفضّلونه | THE OUTNET"; },
      description: function(d) { return ""; },
      keywords: function(d) { return ""; }
    },
    pdpMarkup: {
      nbColours: function(d) { return plural(d.copy, 0, en, { "1": " متاح بلون " + d.color1 + ".الخامة: ", "2": " متاح بلون " + d.color1 + " أو " + d.color2 + ". الخامة: ", other: " متاح بألوان " + number(d.copy, "copy") + ". الخامة: " }); },
      productDescription: function(d) { return d.name + " بلون " + d.color + ". المقاس: " + d.size + ". " + select(d.material, { undefined: "", other: "الخامة: " + d.material + "." }); }
    },
    plpMarkup: {
      name: function(d) { return select(d.category, { undefined: d.designerName, other: d.category + " " + d.designerName }); }
    }
  },
  error: {
    notFound: function(d) { return "عذرًا، لا يمكن العثور على تلك الصفحة."; },
    unknownError: function(d) { return " حدث خطئ ما."; },
    goBack: function(d) { return "الرجوع"; }
  },
  retry: {
    title: function(d) { return "نعتذر، هذه الصفحة غير متاحة "; },
    retrynow: function(d) { return "يُرجى المحاولة مرّة أخرى الآن"; },
    timetoretry: function(d) { return "سنحاول إعادة الاتصال بكم في " + d.seconds + "  ثواني..."; },
    retryingnow: function(d) { return "إعادة المحاولة الآن"; }
  },
  accordionTitles: {
    editorsNotes: function(d) { return "ملاحظات المحرر"; },
    sizeAndFit: function(d) { return "المقاسات والتلائم"; },
    detailsAndCare: function(d) { return "التفاصيل والعناية"; },
    technicalDescription: function(d) { return "التفاصيل"; }
  },
  accordionIds: {
    editorsNotes: function(d) { return "EditorNotes"; },
    sizeAndFit: function(d) { return "SizeAndFit"; },
    detailsAndCare: function(d) { return "Details"; },
    technicalDescription: function(d) { return "DetailsAndCare"; }
  },
  sizeAndFit: {
    sizeDetails: function(d) { return select(d.slash, { slash: " / " + d.label + d.uom, other: d.label + d.uom }); }
  },
  detailsAndCare: {
    imported: function(d) { return "تم جلب هذا المنتج"; },
    madeIn: function(d) { return "صنع في " + d.madeIn; }
  },
  notifications: {
    PAGE_NOT_AVAILABLE: {
      title: function(d) { return "نأسف!"; },
      message: function(d) { return "لقد لاحظنا أنه ليس لديكم الصلاحية لاستخدام الخصومات، لكن لا تقلقوا، فلا يزال هناك الكثير من القطع الجميلة المخبأة للكشف عنها في التصميمات التي وصلتنا جديدًا."; }
    },
    PAGE_CLOSED: {
      title: function(d) { return "نأسف!"; },
      message: function(d) { return "نعتذر، لقد انتهت فترة الخصم الخاص لدينا، لكن لا تقلقوا فهناك الكثير من القطع الجميلة لاكتشافها في مجموعاتنا التي وصلت حديثًا.."; }
    },
    PAGE_SOON: {
      title: function(d) { return "مشرق ومبكر"; },
      message: function(d) { return "تلتقط الطيور المبكرة أرزاقها، لكنكم مُبكرون جدًا هذه المرّة. بينما تنتظرون، لما لا تطّلعون على أجدد المجموعات؟ "; }
    },
    ADD_TO_BAG_MESSAGE_ERROR: function(d) { return "فشل الإضافة إلى الحقيبة"; },
    authToAdd: function(d) { return "لإضافة هذا العنصر إلى قائمة الرغبات الخاصة بكم، يرجى تسجيل الدخول أو التسجيل"; },
    promoPriceSuccess: function(d) { return "تم نسخ رمز الخصم بنجاح"; },
    errors: function(d) { return select(d.error, { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR: " يُرجى اختيار مقاس ", ERR_WISH_LIST_NOT_EXISTS: " لقد تم حذف هذه القائمة. أضيفي هذا المنتج إلى قائمة أمنيات أخرى ", ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: " لقد وصلتِ إلى الحد الأقصى لعدد المنتجات في قائمة أمنياتكِ. قومي بحذف بعض المنتجات لإضافة المزيد من القطع ", ERR_SKU_ALREADY_EXISTS: " هذا المنتج موجود بالفعل في قائمة أمنياتكِ ", NO_SIZE_SELECTED_ERROR: " يُرجى اختيار مقاس ", TEMPORARY_ADD_TO_CART_ERROR: " عذراً، لم تتم إضافة هذا المنتج إلى حقيبة تسوقكِ. يُرجى إعادة المحاولة. ", ADD_TO_CART_IDENTITY_GENERIC_ERROR: " عذراً، لم تتم إضافة هذا المنتج إلى حقيبة تسوقكِ. يُرجى إعادة المحاولة. ", ADD_TO_CART_GENERIC_ERROR: " عذراً، لم تتم إضافة هذا المنتج إلى حقيبة تسوقكِ. يُرجى إعادة المحاولة. ", CART_ITEM_OUT_OF_STOCK: " عذراً، هذا المنتج غير متور حالياً ", CART_ITEM_INSUFFICIENT_STOCK: " عذراً، لم يعد هذا المنتج متوفر لدينا ", CART_ORDER_LINE_QTY_LIMIT: " لقد وصلتِ إلى الحد الأقصى من المنتجات في حقيبة تسوقكِ ", CART_ORDER_LINES_LIMIT: " لقد قمنا بتحديث حقيبة تسوقكِ، حيث أننا نستطيع فقط شحن كمية محدودة من المنتج المختار ", CWXFR0268E: "", NO_UBER_TOKEN_ERROR: "", MODAL_CLOSED: " لحفظ هذا المنتج في قائمة أمنياتكِ، يُرجى تسجيل الدخول أو إنشاء حساب جديد ", CART_DESIGNER_LINE_QTY_LIMIT: " يرجى ملاحظة أنه بالنسبة لهذا المنتج، يُسمح لكِ بشراء ثلاث قِطع فقط من نفس المقاس كحد أقصى. ", other: " لا يمكننا إتمام طلبكِ. يُرجى إعادة المحاولة. " }); }
  },
  promoPrice: {
    codeDescription: function(d) { return "استخدم الرمز"; },
    promotionalPrice: function(d) { return "السعر الترويجي"; }
  },
  shopMore: {
    title: function(d) { return "عرض المنتجات المماثلة"; }
  },
  wearItWith: {
    heading: function(d) { return "ارتدوها مع"; }
  },
  youMayAlsoLike: {
    heading: function(d) { return "وقد يعجبكم أيضًا"; }
  },
  soldOutReducedPage: {
    heading: function(d) { return "عرض منتجات مماثلة"; }
  },
  recentlyViewed: {
    heading: function(d) { return "تم مشاهدته مؤخرًا"; }
  },
  moreByThisDesigner: {
    heading: function(d) { return "More By This Designer"; }
  },
  noResultsSearchPage: {
    dividerHeading: function(d) { return "قد تعجبك هذه العناصر الرائجة"; }
  },
  designers: {
    pageName: function(d) { return "المصممون"; },
    favorite: function(d) { return "Favorite Designer"; },
    mens: function(d) { return "الرجال"; },
    womens: function(d) { return "السيدات"; }
  },
  designersWithSale: {
    pageName: function(d) { return "خصومات المصممين"; }
  },
  deliveryAndReturns: {
    title: function(d) { return "التسليم والإرجاع"; },
    description: function(d) { return "اكتشفوا المزيد عن خيارات التوصيل لدينا وكيفية التبديل أو الإرجاع"; },
    shippingModesIntro: function(d) { return "ستجدون هنا خيارات التوصيل:"; },
    shippingMode: function(d) { return select(d.shipModeCode, { STANDARD: "اعتيادي", EXPRESS: "سريع", NEXT_DAY_DELIVERY: "توصيل في اليوم الثاني", PREMIER_DAYTIME: "خدمة توصيل النهار الأساسية", PREMIER_EVENING: "خدمة توصيل المساء الأساسية", other: "" }); },
    returnsInfo: function(d) { return "من السهل جدّا تبديل أو إرجاع مشترياتكم، ما عليكم سوى أن ترجعوها خلال 28 يومًا."; },
    findOutMoreLink: function(d) { return "معرفة المزيد"; }
  },
  errors: {
    empty: function(d) { return "هذا الحقل مطلوب"; },
    invalid: function(d) { return "يُرجى إدخال " + d.field + "  صحيح"; }
  },
  accountUtility: {
    signupMessage: function(d) { return "يُرجى الاشتراك في رسائل البريد الإلكتروني الخاصة بنا ليتم إعلامكم بالعروض المستقبلية والأحداث القادمة الأخرى."; },
    submit: function(d) { return "Submit"; },
    emailLabel: function(d) { return "Email Address"; }
  },
  recommendations: {
    viewSimilarItems: function(d) { return "عرض المنتجات المماثلة"; }
  },
  manufacturerDetails: {
    title: function(d) { return "Manufacturing Details"; },
    subtitle: function(d) { return "MANUFACTURER INFORMATION"; },
    button: function(d) { return "View manufacturing details"; },
    content: function(d) { return "We have no information on this product at the moment, but we're working to include them in the near future.\n\nPlease check back later for updates."; }
  }
}